module.exports = __webpack_public_path__ + "img/layout-1.e4f2c4dd.jpg";